{
  "common": {
    "loading": "Laden...",
    "cancel": "Stornieren",
    "save": "Speichern",
    "save_changes": "Änderungen speichern",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "submit": "Einreichen",
    "saving": "Speichern...",
    "sending": "Senden...",
    "error": "Fehler",
    "success": "Erfolg",
    "warning": "Warnung",
    "note": "Hinweis",
    "no_data": "Keine Daten",
    "yes": "Ja",
    "no": "NEIN",
    "back": "Zurück",
    "next": "Nächste",
    "previous": "Vorherige",
    "search": "Suchen",
    "filter": "Filter",
    "all": "Alle",
    "none": "Keiner",
    "select": "Wählen",
    "required": "Erforderlich",
    "optional": "Optional",
    "actions": "Aktionen",
    "status": "Status",
    "date": "Datum",
    "time": "Zeit",
    "name": "Name",
    "email": "E-Mail",
    "confirm": "Bestätigen",
    "add": "Hinzufügen",
    "done": "Fertig",
    "unknown": "Unbekannt",
    "days": "Tage",
    "to": "bis"
  },
  "time": {
    "day": "Tag",
    "days": "Tage",
    "hour": "Stunde",
    "hours": "Std.",
    "week": "Woche",
    "weeks": "Wochen",
    "month": "Monat",
    "months": "Monate",
    "year": "Jahr",
    "years": "Jahre",
    "today": "Heute",
    "tomorrow": "Morgen",
    "yesterday": "Gestern"
  },
  "status": {
    "pending": "Ausstehend",
    "approved": "Genehmigt",
    "rejected": "Abgelehnt",
    "cancelled": "Abgesagt",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "deleted": "Gelöscht",
    "connected": "Verbunden",
    "disconnected": "Getrennt",
    "available": "Verfügbar",
    "coming_soon": "Demnächst verfügbar"
  },
  "nav": {
    "dashboard": "Armaturenbrett",
    "planner": "Planer",
    "team": "Team",
    "requests": "Anfragen",
    "calendar": "Kalender",
    "settings": "Einstellungen",
    "audit_trail": "Prüfprotokoll",
    "billing": "Abrechnung",
    "help": "Hilfe",
    "help_center": "Hilfecenter",
    "profile": "Profil",
    "my_balances": "Meine Salden",
    "leave_history": "Urlaubshistorie",
    "restart_tour": "Tour neu starten",
    "logout": "Abmelden",
    "upgrade": "Upgrade auf Pro",
    "upgrade_subtitle": "Alle Funktionen freischalten",
    "view_plans": "Pläne ansehen"
  },
  "header": {
    "profile_settings": "Profileinstellungen",
    "my_profile": "Mein Profil",
    "workspace": "Arbeitsplatz",
    "leave_balances": "Restguthaben",
    "no_balances": "Es wurden keine Urlaubsguthaben gefunden."
  },
  "balance": {
    "unlimited": "Unbegrenzt",
    "days_left": "verbleibende Tage",
    "used": "gebraucht",
    "remaining": "übrig",
    "of": "von"
  },
  "trial": {
    "ends_today": "Ihre Testphase endet heute!",
    "ends_tomorrow": "Ihre Probezeit endet morgen!",
    "ends_in_days": "Der Prozess endet in {days} Tagen.",
    "upgrade_now": "Jetzt aktualisieren"
  },
  "feature_locked": {
    "title": "{feature} ist in Ihrem Tarif nicht verfügbar.",
    "description": "Aktualisieren Sie Ihren Tarif, um diese und weitere Funktionen freizuschalten.",
    "button": "Pläne ansehen"
  },
  "dashboard": {
    "title": "Armaturenbrett",
    "out_today": "Heute erschienen",
    "out_on_date": "Erschienen am {date}",
    "no_absences": "Keine Abwesenheiten",
    "upcoming": "Anstehende Abwesenheiten",
    "upcoming_empty": "Diese Woche sind keine Ausfälle geplant.",
    "my_balance": "Mein Urlaubsguthaben",
    "my_balances": "Meine Kontostände",
    "no_balance_data": "Keine Kontostandsdaten",
    "next_holiday": "Nächster Feiertag",
    "no_holidays": "Keine bevorstehenden Feiertage",
    "next_vacation": "Mein nächster Urlaub",
    "nothing_booked": "Nichts gebucht!",
    "upcoming_birthdays": "Bevorstehende Geburtstage",
    "no_birthdays": "Keine anstehenden Geburtstage",
    "birthday_today": "Heute!",
    "birthday_in_days": "in {days} {unit}",
    "everyone_in_office": "An diesem Tag sind alle im Büro.",
    "request_leave": "Urlaub beantragen",
    "view_calendar": "Kalender anzeigen",
    "view_planner": "Planer anzeigen",
    "contact_support": "Kontaktieren Sie den Support."
  },
  "support": {
    "title": "Kontaktieren Sie den Support.",
    "success_title": "Nachricht gesendet!",
    "success_message": "Wir melden uns so schnell wie möglich bei Ihnen.",
    "intro": "Brauchen Sie Hilfe? Schicken Sie uns eine Nachricht und wir melden uns umgehend bei Ihnen.",
    "subject_label": "Thema",
    "subject_placeholder": "Kurze Beschreibung Ihres Problems",
    "message_label": "Nachricht",
    "message_placeholder": "Bitte beschreiben Sie Ihr Problem oder Ihre Frage detailliert...",
    "send_button": "Nachricht senden"
  },
  "requests": {
    "page_title": "Urlaubsanträge",
    "page_subtitle": "Urlaubsanträge prüfen und verwalten",
    "new_request": "Urlaub beantragen",
    "unpaid_confirm": "Nur {paid} {unit} dieses Antrags sind durch Ihr bezahltes Guthaben gedeckt. Die restlichen {unpaid} {unit} werden als unbezahlter Urlaub genommen. Trotzdem senden?",
    "filter": {
      "pending": "Ausstehend",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt",
      "all": "Alle",
      "all_employees": "Alle Mitarbeiter"
    },
    "table": {
      "employee": "Mitarbeiter",
      "type": "Typ",
      "dates": "Termine",
      "duration": "Dauer",
      "status": "Status",
      "reason": "Grund",
      "actions": "Aktionen"
    },
    "action": {
      "approve": "Genehmigen",
      "reject": "Ablehnen",
      "cancel": "Stornieren"
    },
    "empty": {
      "title": "Keine Anfragen gefunden",
      "pending": "Es liegen keine ausstehenden Anfragen zur Überprüfung vor.",
      "filtered": "Keine Urlaubsanträge entsprechen Ihrem Filter."
    },
    "modal": {
      "reject_title": "Anfrage ablehnen",
      "reason_label": "Ablehnungsgrund",
      "reason_placeholder": "Grund für den Urlaubsantrag...",
      "reject_button": "Ablehnen",
      "request_title": "Urlaub beantragen",
      "employee_label": "Mitarbeiter",
      "leave_type_label": "Urlaubsart",
      "start_date_label": "Startdatum",
      "end_date_label": "Enddatum",
      "start_time_label": "Startzeit",
      "end_time_label": "Endzeit",
      "reason_optional": "Grund (optional)",
      "submit_button": "Anfrage einreichen",
      "submitting": "Wird übermittelt...",
      "minimum_duration": "Mindestens: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Teamkalender",
    "page_subtitle": "Teamabwesenheiten und geplante Urlaubszeiten einsehen",
    "filters": {
      "button": "Filter"
    },
    "sync": {
      "title": "Synchronisieren Sie Ihren Kalender",
      "description": "Verbinden Sie Ihren persönlichen Kalender, um genehmigte Urlaubstage automatisch zu synchronisieren."
    },
    "connect": {
      "google": "Google Kalender",
      "microsoft": "Microsoft Kalender"
    },
    "action": {
      "disconnect": "Trennen",
      "sync_my_leave": "Sync My Leave",
      "sync_team_leave": "Sync Team Leave"
    },
    "connecting": "Verbindung wird hergestellt...",
    "syncing": "Synchronisierung läuft...",
    "autosync": {
      "title": "Automatische Synchronisierung des Teams verlässt",
      "description": "Füge die genehmigten Urlaubszeiten deiner Teammitglieder automatisch deinem Kalender hinzu."
    },
    "filter": {
      "department_label": "Abteilung",
      "all_departments": "Alle Abteilungen",
      "location_label": "Standort",
      "all_locations": "Alle Standorte",
      "leave_type_label": "Urlaubsart",
      "all_types": "Alle Arten",
      "status_label": "Status",
      "all_status": "Alle Status"
    },
    "nav": {
      "today": "Heute"
    },
    "view": {
      "day": "Tag",
      "week": "Woche",
      "month": "Monat"
    },
    "legend": {
      "pending": "Ausstehend",
      "holiday": "Urlaub"
    },
    "day_view": {
      "empty": "Keine Blätter an diesem Tag"
    },
    "more": "+{count} mehr"
  },
  "team": {
    "page_title": "Team",
    "page_subtitle": "Verwalten Sie Ihre Teammitglieder",
    "tab": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "deleted": "Gelöscht"
    },
    "add_user": "Benutzer hinzufügen",
    "import_from_slack": "Import aus Slack",
    "search_placeholder": "Teammitglieder suchen...",
    "table": {
      "name": "Name",
      "email": "E-Mail",
      "department": "Abteilung",
      "location": "Standort",
      "role": "Rolle",
      "status": "Status",
      "manager": "Vorgesetzter",
      "start_date": "Eintrittsdatum",
      "actions": "Aktionen"
    },
    "filter": {
      "all": "Alle",
      "department": "Abteilung",
      "all_departments": "Alle Abteilungen",
      "location": "Standort",
      "all_locations": "Alle Standorte",
      "role": "Rolle",
      "all_roles": "Alle Rollen",
      "search_placeholder": "Suche nach Name oder E-Mail..."
    },
    "role": {
      "owner": "Eigentümer",
      "admin": "Administrator",
      "approver": "Genehmiger",
      "employee": "Mitarbeiter"
    },
    "card": {
      "department": "Abteilung",
      "location": "Standort",
      "manager": "Vorgesetzter",
      "email": "E-Mail",
      "start_date": "Eintrittsdatum",
      "birthday": "Geburtstag",
      "working_days": "Arbeitstage",
      "hours_per_week": "Stunden pro Woche",
      "employment_type": "Beschäftigungsart",
      "full_time": "Vollzeit",
      "part_time": "Teilzeit",
      "contractor": "Auftragnehmer",
      "no_department": "Keine Abteilung",
      "no_location": "Kein Standort",
      "no_manager": "Kein Vorgesetzter"
    },
    "action": {
      "edit": "Bearbeiten",
      "deactivate": "Deaktivieren",
      "activate": "Aktivieren",
      "delete": "Löschen",
      "restore": "Wiederherstellen",
      "permanent_delete": "Endgültig löschen",
      "view_profile": "Profil anzeigen",
      "view_balances": "Guthaben anzeigen",
      "adjust_balance": "Guthaben anpassen",
      "view_history": "Verlauf anzeigen"
    },
    "empty": {
      "title": "Keine Teammitglieder gefunden",
      "active": "Es gibt keine aktiven Teammitglieder.",
      "inactive": "Es gibt keine inaktiven Teammitglieder.",
      "deleted": "Es gibt keine gelöschten Teammitglieder.",
      "filtered": "Keine Teammitglieder entsprechen Ihren Filterkriterien.",
      "search": "Keine Ergebnisse für \"{query}\" gefunden."
    },
    "modal": {
      "edit_title": "Benutzer bearbeiten",
      "add_title": "Benutzer hinzufügen",
      "import_title": "Benutzer aus Slack importieren",
      "name_label": "Vollständiger Name",
      "email_label": "E-Mail-Adresse",
      "department_label": "Abteilung",
      "location_label": "Standort",
      "role_label": "Rolle",
      "manager_label": "Vorgesetzter",
      "start_date_label": "Eintrittsdatum",
      "birthday_label": "Geburtstag",
      "working_days_label": "Arbeitstage",
      "hours_per_week_label": "Stunden pro Woche",
      "employment_type_label": "Beschäftigungsart",
      "select_department": "Abteilung auswählen",
      "select_location": "Standort auswählen",
      "select_role": "Rolle auswählen",
      "select_manager": "Vorgesetzten auswählen",
      "no_manager": "Kein Vorgesetzter",
      "save_button": "Speichern",
      "cancel_button": "Abbrechen"
    },
    "toil": {
      "title": "TOIL",
      "description": "Freizeitausgleich für Überstunden",
      "add_button": "TOIL hinzufügen",
      "hours_label": "Stunden",
      "reason_label": "Grund",
      "date_label": "Datum",
      "balance": "TOIL-Guthaben",
      "no_toil": "Kein TOIL-Guthaben vorhanden"
    },
    "invite": {
      "title": "Mitglied einladen",
      "subtitle": "Laden Sie ein neues Teammitglied per E-Mail ein",
      "email_label": "E-Mail-Adresse",
      "email_placeholder": "email@beispiel.de",
      "role_label": "Rolle",
      "department_label": "Abteilung",
      "send_button": "Einladung senden",
      "success": "Einladung erfolgreich gesendet",
      "error": "Fehler beim Senden der Einladung"
    },
    "bulk": {
      "title": "Massenimport",
      "subtitle": "Importieren Sie mehrere Benutzer aus einer CSV-Datei",
      "upload_button": "CSV-Datei hochladen",
      "download_template": "Vorlage herunterladen",
      "preview_title": "Vorschau",
      "import_button": "Importieren",
      "importing": "Importiere...",
      "success": "{count} Benutzer erfolgreich importiert",
      "error": "Fehler beim Importieren der Benutzer",
      "validation_errors": "Validierungsfehler gefunden",
      "row": "Zeile",
      "from_slack": "Aus Slack importieren",
      "select_users": "Benutzer zum Importieren auswählen"
    },
    "instances": {
      "title": "Urlaubsinstanzen",
      "description": "Zeigt alle Urlaubsinstanzen für diesen Benutzer an",
      "no_instances": "Keine Urlaubsinstanzen vorhanden",
      "lifetime_used": "Insgesamt verwendet",
      "lifetime_remaining": "Verbleibend (Lebenszeit)"
    },
    "confirm": {
      "deactivate": "Sind Sie sicher, dass Sie diesen Benutzer deaktivieren möchten?",
      "deactivate_warning": "Der Benutzer kann sich nicht mehr anmelden und erscheint nicht mehr im Planer.",
      "delete": "Möchten Sie diesen Benutzer wirklich löschen? Er wird in den Tab 'Gelöscht' verschoben.",
      "delete_warning": "Ausstehende Urlaubsanträge werden storniert.",
      "permanent_delete": "Möchten Sie {name} wirklich ENDGÜLTIG LÖSCHEN?",
      "permanent_delete_warning": "Diese Aktion kann nicht rückgängig gemacht werden. Sämtliche Urlaubsansprüche und Guthaben werden gelöscht.",
      "permanent_delete_final": "Dies ist endgültig! Klicken Sie auf OK, um die endgültige Löschung zu bestätigen.",
      "activate": "Möchten Sie diesen Benutzer wirklich aktivieren?",
      "restore": "Möchten Sie diesen Benutzer wirklich wiederherstellen?"
    },
    "error": {
      "deactivate": "Benutzer konnte nicht deaktiviert werden",
      "activate": "Benutzeraktivierung fehlgeschlagen",
      "delete": "Benutzer konnte nicht gelöscht werden",
      "restore": "Benutzer konnte nicht wiederhergestellt werden",
      "permanent_delete": "Fehler beim endgültigen Löschen des Benutzers",
      "load": "Teammitglieder konnten nicht geladen werden",
      "save": "Benutzer konnte nicht gespeichert werden",
      "import": "Benutzer konnten nicht importiert werden",
      "not_found": "Benutzer nicht gefunden"
    }
  },
  "settings": {
    "page_title": "Einstellungen",
    "page_subtitle": "Konfigurieren Sie Ihre Arbeitsbereichseinstellungen und -richtlinien",
    "access_denied": {
      "title": "Administratorzugriff erforderlich",
      "message": "Sie benötigen Administratorrechte, um auf die Einstellungen zugreifen zu können."
    },
    "tab": {
      "workspace": "Arbeitsplatz",
      "departments": "Abteilungen",
      "locations": "Standorte",
      "holidays": "Feiertage",
      "compliance": "Einhaltung",
      "balances": "Anfangssalden",
      "notifications": "Benachrichtigungen",
      "integrations": "Integrationen",
      "import": "Import",
      "data_management": "Datenmanagement",
      "locked_tooltip": "Führen Sie ein Upgrade durch, um diese Funktion freizuschalten."
    },
    "workspace": {
      "title": "Arbeitsbereichseinstellungen",
      "name_label": "Arbeitsbereichsname",
      "visibility_label": "Sichtbarkeit verlassen",
      "visibility": {
        "all": "Jeder kann sehen, wie alle gehen",
        "department": "Siehe nur die eigene Abteilung",
        "approvers": "Nur Genehmiger können alles sehen"
      },
      "save_button": "Änderungen speichern"
    },
    "departments": {
      "title": "Abteilungen",
      "subtitle": "Organisieren Sie Ihr Team in Abteilungen mit individuellen Richtlinien.",
      "add_button": "Abteilung hinzufügen",
      "name_label": "Abteilungsname",
      "working_days_label": "Arbeitstage",
      "hours_per_day_label": "Stunden pro Tag",
      "approvers_label": "Genehmiger",
      "notification_channel_label": "Benachrichtigungskanal",
      "policies_button": "Richtlinien verwalten",
      "edit_button": "Bearbeiten",
      "delete_button": "Löschen",
      "confirm_delete": "Sind Sie sicher, dass Sie diese Abteilung löschen möchten?",
      "no_departments": "Es wurden noch keine Abteilungen erstellt."
    },
    "locations": {
      "title": "Standorte",
      "subtitle": "Bürostandorte und deren Feiertagskalender verwalten",
      "add_button": "Standort hinzufügen",
      "name_label": "Name des Standorts",
      "country_label": "Land",
      "timezone_label": "Zeitzone",
      "edit_button": "Bearbeiten",
      "delete_button": "Löschen",
      "no_locations": "Es wurden noch keine Standorte erstellt."
    },
    "holidays": {
      "title": "Feiertage",
      "subtitle": "Verwalten Sie die Feiertage für jeden Standort",
      "add_button": "Feiertag hinzufügen",
      "location_label": "Standort",
      "all_locations": "Alle Standorte",
      "year_label": "Jahr",
      "name_label": "Feiertagsname",
      "date_label": "Datum",
      "half_day_label": "Halbtag",
      "edit_button": "Bearbeiten",
      "delete_button": "Löschen",
      "no_holidays": "Für diesen Ort und dieses Jahr gibt es keine Feiertage.",
      "import_button": "Importfeiertage"
    },
    "leave_types": {
      "title": "Blattarten",
      "subtitle": "Urlaubsarten und -ansprüche konfigurieren",
      "add_button": "Blatttyp hinzufügen",
      "name_label": "Name",
      "color_label": "Farbe",
      "unit_label": "Einheit",
      "unit": {
        "days": "Tage",
        "hours": "Std"
      },
      "entitlement_label": "Standardberechtigung",
      "unlimited": "Unbegrenzt",
      "requires_approval_label": "Genehmigung erforderlich",
      "allow_half_day_label": "Halben Tag einplanen",
      "is_paid_label": "Bezahlter Urlaub",
      "carryover_label": "Maximaler Übertrag",
      "priority_label": "Priorität",
      "edit_button": "Bearbeiten",
      "delete_button": "Löschen",
      "no_leave_types": "Keine Urlaubsarten konfiguriert"
    },
    "notifications": {
      "title": "Benachrichtigungen",
      "subtitle": "Konfigurieren Sie, wie und wann Benachrichtigungen gesendet werden.",
      "slack_channel_label": "Slack-Kanal",
      "email_notifications_label": "E-Mail-Benachrichtigungen",
      "daily_digest_label": "Tageszusammenfassung",
      "weekly_summary_label": "Wöchentliche Zusammenfassung",
      "save_button": "Einstellungen speichern"
    },
    "integrations": {
      "title": "Integrationen",
      "subtitle": "Verbinden Sie Ihre HR-Tools und Kalender.",
      "connect_button": "Verbinden",
      "disconnect_button": "Trennen",
      "sync_button": "Jetzt synchronisieren",
      "view_logs_button": "Protokolle anzeigen",
      "last_sync": "Letzte Synchronisierung: {Datum}",
      "never_synced": "Nie synchronisiert",
      "status": {
        "connected": "Verbunden",
        "disconnected": "Nicht verbunden",
        "error": "Fehler"
      }
    },
    "data": {
      "title": "Datenmanagement",
      "subtitle": "Sichern Sie Ihre Daten oder löschen Sie die Informationen in Ihrem Arbeitsbereich.",
      "current_data": "Aktuelle Daten",
      "total_users": "Gesamtzahl der Nutzer",
      "admins": "Administratoren",
      "regular_users": "Regelmäßige Nutzer",
      "leave_requests": "Urlaubsanträge",
      "backup": {
        "title": "Backup herunterladen",
        "description": "Laden Sie eine vollständige Sicherungskopie Ihrer Arbeitsbereichsdaten als JSON-Datei herunter.",
        "button": "Backup herunterladen"
      },
      "google_drive": {
        "title": "Google Drive-Backup",
        "description": "Automatische tägliche Datensicherung auf Google Drive.",
        "connect_button": "Google Drive verbinden",
        "folder_label": "Sicherungsordner",
        "auto_backup_label": "Automatische tägliche Datensicherung aktivieren",
        "backup_now_button": "Jetzt sichern",
        "last_backup": "Letzte Sicherung: {Datum}",
        "upgrade_message": "Automatische tägliche Backups auf Google Drive sind im Business-Tarif verfügbar."
      },
      "clear_users": {
        "title": "Benutzer ohne Administratorrechte löschen",
        "description": "Entfernen Sie alle Benutzer außer Administratoren und Inhabern. Dadurch werden {count} Benutzer, deren Urlaubsguthaben und alle ausstehenden Urlaubsanträge gelöscht.",
        "warning": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden. Laden Sie vorher unbedingt eine Sicherungskopie herunter.",
        "confirm_prompt": "Geben Sie LÖSCHEN ein, um zu bestätigen.",
        "confirm_description": "Dadurch werden {count} Benutzer und alle ihre Daten endgültig gelöscht.",
        "button": "Benutzer ohne Administratorrechte löschen",
        "confirm_button": "Benutzer löschen bestätigen"
      },
      "clear_history": {
        "title": "Urlaubsverlauf löschen",
        "description": "Alle Urlaubsanträge werden gelöscht und alle Urlaubsguthaben auf null zurückgesetzt. Dadurch werden {count} Urlaubsanträge gelöscht.",
        "warning": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden. Sämtliche Urlaubsdaten werden dauerhaft gelöscht und Kontostände zurückgesetzt.",
        "confirm_description": "Dadurch werden {count} Urlaubsanträge endgültig gelöscht und alle Guthaben zurückgesetzt.",
        "button": "Urlaubsverlauf löschen",
        "confirm_button": "Bestätigen, den Verlauf zu löschen. Verlauf löschen."
      },
      "restore": {
        "title": "Wiederherstellung aus dem Backup",
        "description": "Laden Sie eine Sicherungs-JSON-Datei hoch, um Ihre Arbeitsbereichsdaten wiederherzustellen. Dadurch werden alle vorhandenen Daten ersetzt.",
        "warning": "Warnung: Durch die Wiederherstellung werden alle aktuellen Benutzer, Urlaubsarten, Urlaubsanträge, Abteilungen und Guthaben überschrieben. Nur der Workspace-Inhaber kann diese Aktion durchführen.",
        "select_file": "Sicherungsdatei auswählen",
        "backup_details": "Sicherungsdetails",
        "file": "Datei",
        "version": "Version",
        "created": "Erstellt",
        "confirm_prompt": "Geben Sie RESTORE ein, um zu bestätigen.",
        "confirm_description": "Dadurch werden alle vorhandenen Daten dauerhaft durch die Sicherungskopie ersetzt.",
        "button": "Wiederherstellung bestätigen",
        "restoring": "Wiederherstellung...",
        "success": "Wiederherstellung erfolgreich abgeschlossen!"
      }
    }
  },
  "audit": {
    "page_title": "Prüfprotokoll",
    "page_subtitle": "Alle in Ihrem Arbeitsbereich vorgenommenen Änderungen anzeigen",
    "super_admin_label": "(Super Admin)",
    "entries_count": "Gesamtzahl der Einträge",
    "filter": {
      "action_label": "Aktionstyp",
      "all_actions": "Alle Aktionen",
      "entity_label": "Entitätstyp",
      "all_entities": "Alle Entitäten",
      "user_label": "Geändert durch",
      "all_users": "Alle Benutzer"
    },
    "action": {
      "user_updated": "Benutzer aktualisiert",
      "user_deleted": "Benutzer gelöscht",
      "user_imported": "Vom Benutzer importiert",
      "leave_requested": "Urlaub beantragt",
      "leave_approved": "Urlaub genehmigt",
      "leave_rejected": "Urlaubsantrag abgelehnt",
      "leave_cancelled": "Urlaub storniert",
      "leave_type_created": "Urlaubsart erstellt",
      "leave_type_updated": "Urlaubsart aktualisiert",
      "leave_type_deleted": "Dateityp „Gelöscht“",
      "balance_adjusted": "Saldo angepasst",
      "department_created": "Abteilung geschaffen",
      "department_updated": "Abteilung aktualisiert",
      "department_deleted": "Abteilung gelöscht",
      "audit_log_deleted": "Überwachungsprotokoll gelöscht"
    },
    "table": {
      "date": "Datum",
      "user": "Benutzer",
      "action": "Aktion",
      "entity": "Juristische Person",
      "details": "Details"
    },
    "no_entries": "Es wurden keine Einträge im Audit-Log gefunden."
  },
  "billing": {
    "page_title": "Abrechnung & Abonnement",
    "page_subtitle": "Verwalten Sie Ihre Abonnement- und Rechnungsdetails",
    "access_denied": {
      "title": "Zugriff verweigert",
      "message": "Nur der Inhaber des Arbeitsbereichs kann die Abrechnung einsehen und verwalten.",
      "button": "Zurück zum Dashboard"
    },
    "current_plan": {
      "title": "Aktueller Plan"
    },
    "status": {
      "none": "Kein Abonnement"
    },
    "discount_badge": "{percent}% Rabatt angewendet",
    "trial_info": {
      "title": "Prozess endet am {Datum}",
      "days_remaining": "{Tage} verbleibende Tage"
    },
    "renewal_info": {
      "title": "Nächster Abrechnungstag"
    },
    "action": {
      "upgrade": "Upgrade auf Pro",
      "view_plans": "Alle Pläne ansehen",
      "manage": "Abonnement verwalten"
    },
    "plan": {
      "trial": "Kostenlose Testversion",
      "free": "Frei",
      "pro": "Pro",
      "business": "Geschäft"
    },
    "feature": {
      "up_to_5_users": "Bis zu 5 Benutzer",
      "up_to_50_users": "Bis zu 50 Benutzer",
      "unlimited_users": "Unbegrenzte Nutzer",
      "basic": "Grundfunktionen",
      "trial_14days": "14-tägige Testphase",
      "unlimited_requests": "Unbegrenzte Urlaubsanträge",
      "slack_integration": "Slack-Integration",
      "planner": "Planeransicht",
      "custom_leave_types": "Benutzerdefinierte Urlaubsarten",
      "approval_workflows": "Genehmigungsworkflows",
      "priority_support": "Prioritätsunterstützung",
      "multi_team": "Unterstützung mehrerer Teams",
      "analytics": "Erweiterte Analysen",
      "api_access": "API-Zugriff",
      "dedicated_support": "Engagierter Support"
    }
  },
  "upgrade": {
    "page_title": "Wählen Sie Ihren Tarif",
    "page_subtitle": "Einfache, transparente Preisgestaltung. Keine Gebühren pro Nutzer.",
    "plan_badge": "Am beliebtesten",
    "period": {
      "month": "/Monat",
      "year": "/Jahr"
    },
    "yearly_savings": "oder EUR {jährlich}/Jahr (Ersparnis {Prozent}%)",
    "loading": "Ladepläne...",
    "guarantee": {
      "title": "30-Tage-Geld-zurück-Garantie",
      "description": "Nicht zufrieden? Sie erhalten eine volle Rückerstattung – ohne Wenn und Aber."
    },
    "faq": {
      "title": "Häufig gestellte Fragen",
      "q1": "Kann ich meine Pläne später ändern?",
      "a1": "Ja, Sie können jederzeit ein Upgrade oder Downgrade durchführen. Änderungen werden sofort wirksam und anteilig berechnet.",
      "q2": "Welche Zahlungsmethoden akzeptieren Sie?",
      "a2": "Wir akzeptieren alle gängigen Kreditkarten (Visa, Mastercard, American Express) über unseren sicheren Zahlungsanbieter Stripe.",
      "q3": "Gibt es einen Vertrag oder eine Verpflichtung?",
      "a3": "Nein, alle Verträge sind monatlich kündbar. Sie können jederzeit ohne Gebühren kündigen.",
      "q4": "Was passiert, wenn ich mein Benutzerlimit erreiche?",
      "a4": "Sie werden aufgefordert, auf einen höherwertigen Tarif aufzurüsten. Bestehende Nutzer behalten weiterhin ihren Zugriff."
    },
    "contact_note": "Haben Sie Fragen? Kontaktieren Sie uns unter",
    "current_plan_badge": "Aktueller Plan",
    "button": {
      "upgrade": "Upgrade auf {Plan}",
      "start_trial": "Kostenlose Testversion starten"
    }
  },
  "login": {
    "processing_title": "Sie werden angemeldet...",
    "processing_message": "Bitte warten Sie, während wir Ihre Zugangsdaten von Slack überprüfen.",
    "subtitle": "Verwalten Sie die Urlaubsanträge Ihres Teams ganz einfach.",
    "slack_button": "Zu Slack hinzufügen",
    "existing_user_text": "Nutzen Sie Unplug bereits?",
    "existing_user_info": "Öffne die App in Slack und klicke auf „Admin-Dashboard“, um dich anzumelden.",
    "terms_text": "Indem Sie fortfahren",
    "error": {
      "workspace_not_found": "Arbeitsbereich nicht gefunden. Bitte überprüfen Sie die URL.",
      "invalid_response": "Ungültige Antwort vom Server",
      "generic": "Fehler bei der Anmeldung",
      "please_retry": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut."
    }
  },
  "help": {
    "page_title": "Hilfezentrum",
    "page_subtitle": "Finden Sie Antworten und erfahren Sie, wie Sie Unplug verwenden.",
    "action": {
      "restart_tour": "Neustart-Tour"
    },
    "search": {
      "placeholder": "Hilfeartikel und FAQs durchsuchen...",
      "results": "Es wurden Artikel ({articles}) und FAQs ({faqs}) gefunden, die dem Suchbegriff {query} entsprechen."
    },
    "quick_link": {
      "getting_started": "Erste Schritte",
      "faqs": "Häufig gestellte Fragen",
      "contact_support": "Kontaktieren Sie den Support.",
      "tour": "Nehmen Sie an der Tour teil"
    }
  },
  "profile": {
    "page_title": "Profileinstellungen",
    "personal_info": "Persönliche Daten",
    "name_label": "Vollständiger Name",
    "email_label": "E-Mail",
    "department_label": "Abteilung",
    "location_label": "Standort",
    "manager_label": "Manager",
    "start_date_label": "Startdatum",
    "save_button": "Änderungen speichern",
    "preferences": "Präferenzen",
    "language_label": "Sprache",
    "timezone_label": "Zeitzone"
  },
  "planner": {
    "page_title": "Planer",
    "page_subtitle": "Visueller Teamkalender mit allen Abwesenheiten",
    "feature_name": "Planer",
    "feature_description": "Visueller Teamkalender mit allen Abwesenheiten auf einen Blick",
    "empty_state": "Keine Teammitglieder gefunden",
    "filter": {
      "pending_request": "Ausstehende Anfrage",
      "filter_by": "Filtern nach",
      "department": "Abteilung",
      "all_departments": "Alle Abteilungen",
      "location": "Standort",
      "all_locations": "Alle Standorte"
    },
    "export": {
      "button": "Exportieren",
      "title": "Urlaubsdaten exportieren",
      "format": "Exportformat",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "Generisches CSV",
      "date_range": "Zeitraum",
      "departments": "Abteilungen"
    },
    "legend": {
      "approved": "Genehmigt",
      "pending": "Ausstehend",
      "holiday": "Feiertag",
      "holidays": "Feiertage",
      "weekend": "Wochenende",
      "non_working": "Arbeitsfreier Tag",
      "partial_day": "Abwesenheiten kürzer als ein Tag"
    },
    "no_data": "Keine Abwesenheiten anzuzeigen"
  },
  "error": {
    "network": "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
    "unauthorized": "Sie sind nicht befugt, diese Aktion durchzuführen.",
    "not_found": "Die angeforderte Ressource wurde nicht gefunden.",
    "server": "Serverfehler. Bitte versuchen Sie es später erneut.",
    "validation": "Bitte überprüfen Sie das Formular auf Fehler.",
    "generic": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "session_expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an."
  },
  "success": {
    "saved": "Änderungen erfolgreich gespeichert.",
    "deleted": "Erfolgreich gelöscht.",
    "created": "Erfolgreich erstellt.",
    "updated": "Aktualisierung erfolgreich.",
    "submitted": "Erfolgreich übermittelt.",
    "sent": "Erfolgreich gesendet."
  },
  "weekday": {
    "monday": "Montag",
    "tuesday": "Dienstag",
    "wednesday": "Mittwoch",
    "thursday": "Donnerstag",
    "friday": "Freitag",
    "saturday": "Samstag",
    "sunday": "Sonntag",
    "mon": "Montag",
    "tue": "Di.",
    "wed": "Heiraten",
    "thu": "Donnerstag",
    "fri": "Freitag",
    "sat": "Sa",
    "sun": "Sonne"
  },
  "month": {
    "january": "Januar",
    "february": "Februar",
    "march": "Marsch",
    "april": "April",
    "may": "Mai",
    "june": "Juni",
    "july": "Juli",
    "august": "August",
    "september": "September",
    "october": "Oktober",
    "november": "November",
    "december": "Dezember",
    "jan": "Januar",
    "feb": "Februar",
    "mar": "Beschädigen",
    "apr": "April",
    "may_short": "Mai",
    "jun": "Juni",
    "jul": "Jul",
    "aug": "August",
    "sep": "September",
    "oct": "Oktober",
    "nov": "November",
    "dec": "Dezember"
  },
  "language": {
    "en": "Englisch",
    "es": "Spanisch",
    "fr": "Französisch",
    "de": "Deutsch",
    "it": "Italienisch",
    "pt": "Portugiesisch",
    "pl": "Polieren",
    "nl": "Niederländisch",
    "sv": "Schwedisch",
    "no": "norwegisch"
  },
  "leave_type_name": {
    "Vacation": "Urlaub",
    "Vacation Leave": "Urlaub",
    "Annual Leave": "Jahresurlaub",
    "Unpaid Vacation": "Unbezahlter Urlaub",
    "Unpaid Leave": "Unbezahlter Urlaub",
    "Sick Leave": "Krankheit",
    "Sick Leave (Full Pay)": "Krankheit (volle Bezahlung)",
    "Maternity Leave": "Mutterschaftsurlaub",
    "Paternity Leave": "Vaterschaftsurlaub",
    "Parental Leave": "Elternzeit",
    "Bereavement Leave": "Trauerurlaub",
    "Marriage Leave": "Hochzeitsurlaub",
    "Jury Leave": "Geschworenenurlaub",
    "Jury Duty": "Geschworenenpflicht",
    "Work Travel": "Dienstreise",
    "Working Remotely": "Homeoffice",
    "Remote Work": "Homeoffice",
    "Work From Home": "Homeoffice",
    "Personal Day": "Persönlicher Tag",
    "TOIL": "Freizeitausgleich",
    "Time Off In Lieu": "Freizeitausgleich",
    "Compassionate Leave": "Sonderurlaub",
    "Study Leave": "Bildungsurlaub",
    "Training": "Schulung",
    "Public Holiday": "Feiertag"
  }
}